export default __webpack_public_path__ + "static/media/logo-flexible.cfbeff45.png";